module.exports = __webpack_public_path__ + "img/infc_refc.b742296c.jpg";